<template>
	<div class="page" data-name="payment-result-view">
		<f7-navbar>
			<f7-nav-left>
				<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
			</f7-nav-left>
			<div class="title">결제 상세내역</div>
			<f7-nav-right>
				<f7-link icon-ios="f7:close" icon-aurora="f7:close" icon-md="material:close" class="back"></f7-link>
			</f7-nav-right>
		</f7-navbar>
	
		<div class="page-content" style="background-color:#efeff4">	
			<div class="block-title" v-if="onlyOnlineCheck == false">주소지 정보</div>
			<div class="card card-outline" v-if="onlyOnlineCheck == false">
				<div class="card-content card-content-padding">
					<div class="list">
						<ul>
							<li class="item-content item-input item-input-outline">
								<div class="item-inner">
									<div class="item-title item-floating-label ">이름</div>
									<div class="item-input-wrap ">
										<input type="text" name="userName" id="userName" ref="userName" readonly disabled>										
									</div>						
								</div>
							</li>
							<li class="item-content item-input item-input-outline row">      
								<div class="col-60">
									<div class="item-inner">		
										<div class="item-title item-floating-label ">우편번호</div>						
										<div class="item-input-wrap">
											<input type="text" name="post" ref="postNo" readonly disabled>									
										</div>
									</div>
								</div>								
							</li>	
							<li class="item-content item-input item-input-outline">      
								<div class="item-inner">			
									<div class="item-title item-floating-label ">주소</div>						
									<div class="item-input-wrap">														
										<input type="text" name="address" ref="address" readonly disabled>								
									</div>
								</div>
							</li>	
								<li class="item-content item-input item-input-outline">      
								<div class="item-inner">
									<div class="item-title item-floating-label">상세주소</div>
									<div class="item-input-wrap">
										<input type="text" name="subAddress" ref="subAddress" readonly disabled>										
									</div>
								</div>
							</li>
							<li class="item-content item-input item-input-outline row">      
								<div class="item-inner">
									<div class="item-title item-floating-label">휴대폰번호 및 연락처 입력</div>
									<div class="item-input-wrap">
										<input type="tel" name="mobile" ref="mobile" readonly disabled>										
									</div>
								</div>
							</li>					
						</ul>
					</div>
				</div>
			</div>
			<div class="block-title">상품 정보</div>
			<div class="card card-outline">
				<div class="card-content card-content-padding">
					<div class="list media-list">
						<ul>
							<template v-for="(item,i) in paymentList">
								<li :key="'ii' + i" class="item-content">
									<div class="item-media">
										<img :src="productImageUrl(i)"/>
									</div>
									<div class="item-inner">
										<div class="item-title-row">
											<div class="item-title">
												{{item.PRODUCT_NAME}}
											</div>
										</div>
										<div class="item-subtitle">
											{{item.USER_NAME}} 학생 /
											{{getPrice(item.ORIGINAL_PRICE-item.DISCOUNT_PRICE)}}원
										</div>
									</div>
								</li>
							</template>
						</ul>
					</div>
				</div>
			</div>

			<div class="block-title">최종 결제정보 ({{paymentList.length}}개)</div>
			<div class="card card-outline">
				<div class="card-content card-content-padding">
					<div class="list no-hairlines-between">
						<ul>
							<li>
								<div class="item-content">
									<div class="item-inner">
										<div class="item-title">상품금액 :</div>
										<div class="item-after"><b>{{getPrice(productsPrice)}} 원</b></div>
									</div>
								</div>
							</li>
							<li>
								<div class="item-content">
									<div class="item-inner">
										<div class="item-title">할인금액 :</div>
										<div class="item-after"><b style="color:#ff0000">-{{getPrice(discountPrice)}} 원</b></div>
									</div>
								</div>
							</li>
							<li>
								<div class="item-content">
									<div class="item-inner">
										<div class="item-title">배송비 :</div>
										<div class="item-after"><b>+{{getPrice(shipPrice)}}원</b></div>
									</div>
								</div>
							</li>
							<li>
								<div class="item-content">
									<div class="item-inner">
										<div class="item-title">결제금액 :</div>
										<div class="item-after"><h3><b style="color:#00aaff">{{getPrice(orderPrice)}}원</b></h3></div>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="block-title">결제수단</div>
			<div class="card card-outline margin-bottom">
				<div class="card-content card-content-padding">
					<div class="list media-list">
						<ul>
							<li>								
								<div class="item-inner">
									<div class="item-title padding-left">{{iniPayType}}</div>
								</div>								
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import AUTH from '../../../js/common/auth.js';
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';

export default {
	data() {
		return {
			paymentList: [],
			onlyOnlineCheck: true,
			orderPrice: 0,
			shipPrice: 0,			
			productsPrice: 0,
			discountPrice: 0,
			shipType: "prepaid",	
			orderKey: 0,
			iniPayType: "카드결제"
		}
	},
	mounted() {
		const _this = this;
		_this.orderKey = _this.$f7route.context.orderKey;
		_this.getOrderInfo();
	},
	methods: {
		getOrderInfo() {
			const _this = this;

			let param = {
				pOrderKey : _this.orderKey
			}
			
			API.ajaxRequest({
				url: API.getOrderInfoUrl(),
				data: param
			}).then(function (data) {				
				_this.paymentList = data.paymentList;				
				_this.calcPayment(data);							
			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
			
		},
		getPrice(price) {
			const _this = this;
			var won = MODULE.Util.autoMakeComma(price);
			return won;
		},
		productImageUrl(itemIndex) {
			const _this = this;
			var item = _this.paymentList[itemIndex];
			var imgPath = MODULE.Util.getProductImgUrl(item.PRODUCT_KEY);			

			return CONST.contentServerUrl + "/websvr/contents/common/matchbookimage/d4-01/d2-00/bi-10001/10001-bookimage.png";			
		},
		calcPayment(data) {
			const _this = this;
			var itemPrice = 0;
			var itemDiscountPrice = 0;
			var itemShipPrice = 0;
			var itemShipPriceCheck = false;			

			for(var i = 0; i < _this.paymentList.length; i++) {
				var item = _this.paymentList[i];

				itemPrice += item.ORIGINAL_PRICE;
				itemDiscountPrice += item.DISCOUNT_PRICE;

				if(!itemShipPriceCheck && 
					CONST.productType[item.PRODUCT_TYPE].shipPrice > 0) { // 배송비가 붙은 제품이면 
					itemShipPriceCheck = true;					
				}

				if(CONST.productType[item.PRODUCT_TYPE].id != "online") {
					_this.onlyOnlineCheck = false;
				}
			}

			_this.productsPrice = itemPrice;
			_this.discountPrice = itemDiscountPrice;
			
			if(itemShipPriceCheck && (_this.productsPrice < 25000)) { // 현재 강아 기준 상품 금액 이하면 배송비 붙음
				_this.shipPrice = 4000;
				//조건에 따라 선불 및 후불 배송 타입 결정 지금은 선불 배송비로 fix
				_this.shipType = "prepaid";
			}else {
				_this.shipType = "freeship";
			}

			_this.orderPrice = _this.productsPrice - _this.discountPrice + _this.shipPrice;
	
			if(!_this.onlyOnlineCheck){
				_this.$utils.nextTick(function() {
					_this.setAddressInfo(data.shipInfo);
				});					
			}

			_this.iniPayType = CONST.iniPayMethod[data.shipInfo.INI_PAY_METHOD].name;  
		},
		setAddressInfo(info) {

			try {
				const _this = this;
				
				var address = info.SHIP_ADDR.split(".");     				
				_this.setElement(_this.$refs.userName, info.ORDER_USER_NAME);
				_this.setElement(_this.$refs.mobile, info.SHIP_MOBILE);
				_this.setElement(_this.$refs.postNo, info.SHIP_POSTCODE);
				_this.setElement(_this.$refs.address, address[0]);
				_this.setElement(_this.$refs.subAddress, address[1]);
				
			}catch(e) {
  
			}
		},
		setElement(element,value){
			var el = $(element);
			el.val(value);
			el.addClass("input-with-value");
			el.parents("li").addClass("item-input-with-value");
		}

	}
	
}
</script>